import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import { capitalize } from "@mui/material";
import { SendPostRequest } from "../../http";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import HeaderWrapper from "../Header/HeaderWrapper";
import FooterWrapper from "../Footer/FooterWrapper";
import TextMainBannerWrapper from "../TextMainBanners/TextMainBannerWrapper";

function CareerDetails() {
    const sitedata = useSelector((store) => store.global.loginData);
    const { id } = useParams();

    const [loading, setLoading] = useState(true);
    const [careerDetailData, setCareerDetailData] = useState({});
    const [segmentList, setSegmentList] = useState([]);

    const [cvData, setCvData] = useState({
        full_name: "",
        email: "",
        contact_no: "",
        address: "",
        // segments: "",
        experience: "",
        education: "",
        certifications: "",
        previous_work: "",
        languages: "",
        linkedin: "",
        message: "",
        cv_file: null,
        cv_ext: "",
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const formRef = useRef(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        getCareerData();
    }, [sitedata]);

    const getCareerData = async () => {
        const response = await SendPostRequest("careers/job-detail", {
            job_id: id,
        });
        setCareerDetailData(response?.data);
        setSegmentList(
            response?.data?.segments_list?.map((segment) => ({
                value: segment.id,
                label: segment.title,
            }))
        );
        setLoading(false);
    };

    const handleFileChange = (e) => {
        let name = e.target.name;
        let file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = () => {
            const base64String = reader.result.split(",")[1];
            setCvData((prevData) => ({
                ...prevData,
                cv_ext: file.name.split(".").pop(),
                [name]: base64String,
            }));
        };
        reader.readAsDataURL(file);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!cvData.full_name) {
            toast.error("Incomplete Form");
            return;
        } else if (!cvData.contact_no) {
            toast.error("Incomplete Form");
            return;
        } else if (cvData.contact_no.length > 14 || cvData.contact_no.length < 10) {
            toast.error("Invalid Contact Number");
            return;
        } else if (!cvData.email) {
            toast.error("Incomplete Form");
            return;
        }
        //  else if (!cvData.segments) {
        //     toast.error("Incomplete Form");
        //     return;
        // } 
        else if (!cvData.cv_file) {
            toast.error("Incomplete Form");
            return;
        }

        try {
            setIsSubmitting(true);
            const response = await SendPostRequest("careers/drop-cv", {
                ...cvData,
                position: id,
                segments: careerDetailData?.segments || ""
            });
            formRef.current.reset();
            if (response.status === "success") {
                setCvData({
                    full_name: "",
                    email: "",
                    contact_no: "",
                    address: "",
                    // segments: "",
                    experience: "",
                    education: "",
                    certifications: "",
                    previous_work: "",
                    languages: "",
                    linkedin: "",
                    message: "",
                    cv_file: null,
                    cv_ext: "",
                });
                toast.success(response.message);
            } else {
                let errorMessage = response.message || "An error occurred";
                toast.error(`Error: ${errorMessage}`);
                console.error("Error fetching data:", errorMessage);
            }
        } catch (error) {
            toast.error(`Error: ${error.message}`);
            console.error("Error fetching data:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCvData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            console.log("Enter key pressed");
        }
    };

    return (
        <div className="page-wrapper-inner">
            <HeaderWrapper />
            <TextMainBannerWrapper
                Heading={careerDetailData?.title || "Career Details"}
                Image="theme-2-banner-career.webp"
            />

            {/* Career Details Section */}

            {sitedata?.theme_drop_cv_form === "colored" ? (
                <div className="pt-4" style={{ background: "#000" }}>
                    <div className="container">
                        <div className="contact-form" data-animation="fadeInLeft">
                            <form ref={formRef} onSubmit={handleSubmit} onKeyDown={handleKeyDown}>
                                <div className="row p-4">
                                    <div className="col-lg-6 mb-3 color-form-inputs">
                                        <label className="form-label mb-0 text-white">
                                            Full Name <span className="asterisk">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="input-name form-control"
                                            placeholder="Enter Full Name"
                                            name="full_name"
                                            value={cvData.full_name}
                                            onChange={handleInputChange}
                                        />
                                    </div>

                                    <div className="col-lg-6 mb-3 color-form-inputs">
                                        <label className="form-label mb-0 text-white">
                                            Contact Number <span className="asterisk">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            className="input-name form-control"
                                            placeholder="Enter Contact Number"
                                            name="contact_no"
                                            value={cvData.contact_no}
                                            onChange={handleInputChange}
                                            maxLength={14}
                                            minLength={10}
                                        />
                                    </div>

                                    <div className="col-lg-6 mb-3 color-form-inputs">
                                        <label className="form-label mb-0 text-white">
                                            Email Address <span className="asterisk">*</span>
                                        </label>
                                        <input
                                            type="email"
                                            className="input-name form-control"
                                            placeholder="Enter Email Address"
                                            name="email"
                                            value={cvData.email}
                                            onChange={handleInputChange}
                                        />
                                    </div>

                                    {/* <div className="col-lg-6 mb-3 color-form-select">
                                        <label className="form-label text-white">
                                            Departments <span className="asterisk">*</span>
                                        </label>
                                        <Select
                                            className="theme-2-gender-select"
                                            name="segments"
                                            options={segmentList}
                                            placeholder="Select...."
                                            value={segmentList.find(
                                                (option) => option?.value === cvData?.segments
                                            )}
                                            onChange={(option) =>
                                                setCvData((prevData) => ({
                                                    ...prevData,
                                                    segments: option?.value,
                                                }))
                                            }
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                singleValue: (base) => ({
                                                    ...base,
                                                    color: "white",
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    color: "white",
                                                }),
                                                input: (base) => ({
                                                    ...base,
                                                    color: "white",
                                                }),
                                                option: (base) => ({
                                                    ...base,
                                                    color: "black",
                                                }),
                                            }}
                                        />
                                    </div> */}

                                    <div className="col-lg-6 mb-3 colored-drop-cv">
                                        <label className="form-label text-white">
                                            Upload Your CV <span className="asterisk">*</span>
                                        </label>
                                        <input
                                            type="file"
                                            className="input-name form-control career_drop_cv_pic_upoload_field"
                                            placeholder="Upload CV"
                                            name="cv_file"
                                            onChange={handleFileChange}
                                        />
                                    </div>

                                    <div className="col-lg-12 mb-3">
                                        <label className="form-label text-white">Message</label>
                                        <textarea
                                            cols="30"
                                            rows="3"
                                            className="input-name form-control"
                                            placeholder="Type Your Message Here"
                                            name="message"
                                            value={cvData.message}
                                            onChange={handleInputChange}
                                        ></textarea>
                                    </div>

                                    <div className="col-lg-12 mb-3">
                                        <div className="d-flex justify-content-end colored-drop-cv-btn">
                                            <button
                                                type="submit"
                                                disabled={isSubmitting}
                                                className="btn"
                                                style={{ width: "150px" }}
                                            >
                                                {isSubmitting ? "Submitting..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="container mt-4">
                    <div className="contact-form" data-animation="fadeInLeft">
                        <form ref={formRef} onSubmit={handleSubmit} onKeyDown={handleKeyDown}>
                            <div className="row p-4">
                                <div className="col-lg-6 mb-3 light-inputs-wrapper">
                                    <label className="form-label">
                                        Full Name <span className="asterisk">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="input-name form-control"
                                        placeholder="Enter Full Name"
                                        name="full_name"
                                        value={cvData.full_name}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                <div className="col-lg-6 mb-3 light-inputs-wrapper">
                                    <label className="form-label">
                                        Contact Number <span className="asterisk">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        className="input-name form-control"
                                        placeholder="Enter Contact Number"
                                        name="contact_no"
                                        value={cvData.contact_no}
                                        onChange={handleInputChange}
                                        maxLength={14}
                                        minLength={10}
                                    />
                                </div>

                                <div className="col-lg-6 mb-3 light-inputs-wrapper">
                                    <label className="form-label">
                                        Email Address <span className="asterisk">*</span>
                                    </label>
                                    <input
                                        type="email"
                                        className="input-name form-control"
                                        placeholder="Enter Email Address"
                                        name="email"
                                        value={cvData.email}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                {/* <div className="col-lg-6 mb-3 light-select-wrapper">
                                    <label className="form-label">
                                        Departments <span className="asterisk">*</span>
                                    </label>
                                    <Select
                                        className="drop_cv_select"
                                        name="segments"
                                        options={segmentList}
                                        placeholder="Select...."
                                        value={segmentList.find(
                                            (option) => option?.value === cvData?.segments
                                        )}
                                        onChange={(option) =>
                                            setCvData((prevData) => ({
                                                ...prevData,
                                                segments: option?.value,
                                            }))
                                        }
                                    />
                                </div> */}

                                <div className="col-lg-6 mb-3 light-inputs-wrapper">
                                    <label className="form-label">
                                        Upload Your CV <span className="asterisk">*</span>
                                    </label>
                                    <input
                                        type="file"
                                        className="input-name form-control career_drop_cv_pic_upoload_field"
                                        placeholder="Upload CV"
                                        name="cv_file"
                                        onChange={handleFileChange}
                                    />
                                </div>

                                <div className="col-lg-12 mb-3 light-inputs-wrapper">
                                    <label className="form-label">Message</label>
                                    <textarea
                                        cols="30"
                                        rows="3"
                                        className="input-name form-control"
                                        placeholder="Type Your Message Here"
                                        name="message"
                                        value={cvData.message}
                                        onChange={handleInputChange}
                                    ></textarea>
                                </div>

                                <div className="col-lg-12 mb-3">
                                    <div className="d-flex justify-content-end">
                                        <button
                                            type="submit"
                                            disabled={isSubmitting}
                                            className="btn btn-default"
                                            style={{ width: "110px" }}
                                        >
                                            {isSubmitting ? "Submitting..." : "Submit"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            <div className="cs_height_50 cs_height_lg_50"></div>
            <FooterWrapper />
        </div>
    );
}

export default CareerDetails;